import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ログアウトしてもよろしいですか？")
], -1)
const _hoisted_2 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" 確認 ")
    ]),
    "modal-content": _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "閉じる"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, "ログアウト")
      ])
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}